import { useEffect, useState } from "react";
import { siteMeta } from "@/mocks/crash";

const navItems = [
  { label: "事件现场", href: "#events" },
  { label: "塌房档案", href: "#types" },
  { label: "崩塌路径", href: "#flow" },
  { label: "深度专题", href: "#deep" },
  { label: "吃瓜手册", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-paper-50/95 backdrop-blur border-b border-paper-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex items-center justify-between px-4 md:px-8 h-16 md:h-[72px]">
        <a
          href="#top"
          onClick={() => setOpen(false)}
          className="flex items-center gap-2 group cursor-pointer"
          aria-label="塌房观察室 首页"
        >
          <span
            className={`grid place-items-center w-9 h-9 rounded-full ${
              scrolled || open ? "bg-ink-900 text-paper-50" : "bg-paper-50 text-ink-900"
            } group-hover:bg-coral-500 group-hover:text-white transition-colors`}
          >
            <i className="ri-focus-3-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-display text-lg tracking-wide ${
                scrolled || open ? "text-ink-900" : "text-paper-50"
              }`}
            >
              {siteMeta.brand}
            </span>
            <span
              className={`text-[10px] tracking-[0.28em] uppercase ${
                scrolled || open ? "text-ink-700/60" : "text-paper-50/70"
              }`}
            >
              {siteMeta.englishLabel}
            </span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navItems.map((it) => (
            <a
              key={it.href}
              href={it.href}
              className={`px-3.5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-ink-800 hover:text-coral-600 hover:bg-coral-50"
                  : "text-paper-50/90 hover:text-white hover:bg-white/10"
              }`}
            >
              {it.label}
            </a>
          ))}
          <a
            href="#manual"
            className="ml-3 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-coral-500 hover:bg-coral-600 text-white text-sm font-semibold px-4 py-2 transition-colors"
          >
            开始吃瓜
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden grid place-items-center w-10 h-10 rounded-full cursor-pointer ${
            scrolled || open ? "text-ink-900" : "text-paper-50"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-paper-200/70 bg-paper-50 px-4 pt-2 pb-6">
          <div className="flex flex-col gap-1">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-lg text-ink-800 hover:bg-coral-50 hover:text-coral-600 text-base"
              >
                {it.label}
              </a>
            ))}
            <a
              href="#manual"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-coral-500 text-white font-semibold px-4 py-3"
            >
              开始吃瓜 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}